import React from 'react';
import { Link } from 'react-router-dom';
import { Lightbulb } from 'lucide-react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const ClueCardSimple = ({ clue, date, isToday, puzzleNumber, linkPrefix }) => {
  // Determine link target based on whether it's today's puzzle or an archive one
  let linkTarget;
  if (linkPrefix) {
      linkTarget = `${linkPrefix}/${clue.slug}`;
  } else {
      linkTarget = isToday 
        ? `/todays-pocket-grids-clues-answers/${clue.slug}` 
        : `/pocket-grid-${puzzleNumber || (date && clue.puzzleNumber ? clue.puzzleNumber : date)}/${clue.slug}`;
  }

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-xl border border-gray-200 p-5 mb-4 shadow-card hover:shadow-card-hover hover:border-brand-blue/30 transition-all duration-300"
    >
      {/* Header: Number + Text */}
      <div className="flex items-start gap-3 mb-4">
        {clue.number && (
          <div className={cn(
            "flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center font-mono font-bold text-sm border",
            clue.direction === 'across' 
              ? "bg-gray-900 text-white border-gray-900" 
              : "bg-brand-yellow text-yellow-900 border-brand-yellow"
          )}>
            {clue.number}
          </div>
        )}
        <h3 className={cn("text-lg font-bold text-gray-900 leading-snug pt-0.5", !clue.number && "pt-0")}>
          {clue.text || `Clue ${clue.number}`}
        </h3>
      </div>

      {/* Actions */}
      <div className="flex gap-3 pl-11">
        <Link 
          to={linkTarget}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-brand-blue/10 text-brand-blue rounded-lg text-sm font-bold hover:bg-brand-blue hover:text-white transition-colors border border-brand-blue/20"
        >
          <Lightbulb className="w-4 h-4" />
          View Hints & Answer
        </Link>
      </div>
    </motion.div>
  );
};

export default ClueCardSimple;
